function ProjectCellRenderer(params) {

  const celldata = params.colDef?.options;

  try {
    if (params.colDef.attribute_type === "external_api") {
      if (Array.isArray(params.value)) {
        let result = params.value.map((itm, index, array) => {
          if (index + 1 === array.length) {
            return [
              <a
                href={`${params.colDef.page_url}${itm}`}
                className="link-er"
                target="_blank"
              >
                {itm}
              </a>,
            ];
          } else {
            return [
              <a
                href={`${params.colDef.page_url}${itm}`}
                className="link-er"
                target="_blank"
              >
                {itm}
              </a>,
              ",",
            ];
          }
        });

        return result;
      } else {
        return [
          <a
            href={`${params.colDef.page_url}}${params.value}`}
            className="link-er"
            target="_blank"
          >
            {params.value}
          </a>,
        ];
      }
    }
    if (Array.isArray(params.value)) {
      const result = params.value.map((itm, index, array) => {
        try {
          if (typeof itm === "string" || typeof itm === "number") {
            const isLast = index + 1 === array.length;
            return [
              <a
                key={index}
                href={`//${process.env.REACT_APP_LOCAL_URL}/tattle/${params.colDef.field}/${itm.toString()}`}
                className="link-er"
                target="_blank"
                rel="noopener noreferrer"
              >
                {itm.toString()}
              </a>,
              !isLast ? "," : "",
            ];
          } else {
            console.warn("Skipping invalid array item:", itm);
            return null;
          }
        } catch (innerErr) {
          console.error("Error processing array item:", itm, innerErr);
          return null;
        }
      });

      return result.filter(Boolean);
    } else {
      // ✅ Handle single value safely
      if (typeof params.value === "string" || typeof params.value === "number") {
        return [
          <a
            href={`//${process.env.REACT_APP_LOCAL_URL}/tattle/${params.colDef.field}/${params.value.toString()}`}
            className="link-er"
            target="_blank"
            rel="noopener noreferrer"
          >
            {params.value.toString()}
          </a>,
        ];
      } else {
        console.warn("Invalid single value:", params.value);
        return [""]; // Return empty if invalid
      }
    }
  } catch (err) {
    console.error("Error rendering project cell:", err);
    return [""]; // Graceful fallback
  }

}

export default ProjectCellRenderer;
